import React, { useEffect, useRef } from 'react'
import { useParams } from 'react-router'
import useResizeObserver from 'use-resize-observer'
import Loading from '../../components/Loading/Loading'
import LastLookModal from '../../components/Modal/LastLookModal/LastLookModal'
import { useOpenFin } from '../../helpers/hooks/useOpenFin'
import { useAppSelector } from '../../store/types'
import { getLastLookWindows } from '../../store/windows/selectors'

const OpenFinLastLook = () => {
  const { id } = useParams()
  const { changeDimensions } = useOpenFin()
  const lastHeightRef = useRef<number | undefined>()
  const { ref, height } = useResizeObserver<HTMLDivElement>()

  const lastLookWindows = useAppSelector(getLastLookWindows)
  const windowInfo = lastLookWindows.find((win) => win.orderId === id)

  useEffect(() => {
    if (height && height !== lastHeightRef.current) {
      changeDimensions(`LastLook/${id}`, 415, height)
      lastHeightRef.current = height
    }
  }, [height, id, changeDimensions])

  if (!windowInfo) return <Loading />
  return (
    <div ref={ref}>
      <LastLookModal key={id} windowInfo={windowInfo} />
    </div>
  )
}

export default OpenFinLastLook
